<div class="create-allie-container">
  <div class="header-form alt-row-between">
    <p class="create-title alt-inter-bold alt-size-20 alt-color-grayscale1">{{"USERS.create-user" | translate}}</p>
    <mat-icon class="close-form pointer" svgIcon="crossMenu" (click)="closeForm()"></mat-icon>
  </div>
  <p class="create-instructions alt-color-grayscale1 alt-inter-medium alt-size-16">{{"USERS.introduce-data" | translate }}</p>

  <form [formGroup]="alliedForm" class="input-format alt-flex-column" autocomplete="off">

    <mat-form-field [hideRequiredMarker]="hideRequiredControl.value" class="form-field margin-field1"
      appearance="outline">
      <mat-label class="alt-inter-medium alt-size-16 alt-color-grayscale1">{{"USERS.allied-name" | translate }}</mat-label>
      <input matInput formControlName="name_ally">
    </mat-form-field>

    <mat-form-field [hideRequiredMarker]="hideRequiredControl.value" class="form-field margin-field1"
      appearance="outline">
      <mat-label class="alt-inter-medium alt-size-16 alt-color-grayscale1">{{"USERS.allied-category" | translate }}</mat-label>
      <mat-select matInput formControlName="category">
        <mat-option *ngFor="let option of typesOptionsOrganization" [value]="option">
          <p class=" alt-inter-medium  alt-size-14 alt-color-grayscale1">{{option}}</p>
        </mat-option>
      </mat-select>
    </mat-form-field>

    <p class="select-country alt-inter-regular alt-size-14">{{"USERS.choose-country" | translate }}:</p>

    <mat-radio-group class="chips-country-container alt-row-between radio-btn" aria-label="Select an option"
      formControlName="country">
      <div *ngFor="let level of allieCategory; index as i">
        <div class="country-chip-container alt-justify-center pointer" *ngIf="level.country_code != ''"
          [class.active]="countrySelected === i" (click)="chooseCountry(i)">
          <mat-icon class="country-flag" [svgIcon]="level.flag"></mat-icon>
          <p class="country-name alt-inter-bold alt-size-12 alt-color-grayscale2 ">{{level.option2}}</p>
        </div>
      </div>
    </mat-radio-group>

    <p class="select-allied-level alt-color-grayscale1 alt-inter-regular alt-size-14">{{"USERS.select-allied-lvl" | translate }}:</p>

    <mat-radio-group class="chips-level-container alt-row-between radio-btn" aria-label="Select an option"
      formControlName="ally_level">
      <div class="chip-container alt-justify-center pointer" *ngFor="let level of alliedLevels; index as i"
        [class.active]="levelSelected === i" (click)="getLevleAllied(i)">
        <p class="chip-level  alt-inter-bold alt-size-12">{{level.level | uppercase}}</p>
      </div>
    </mat-radio-group>

    <div class="date-fields alt-row-align-center">
      <mat-form-field [hideRequiredMarker]="hideRequiredControl.value" class="form-date-field" appearance="outline">
        <mat-label class="alt-inter-medium alt-size-16 alt-color-grayscale1">{{"USERS.date-ini" | translate }}</mat-label>
        <input #date1 matInput [min]="minDate" [matDatepicker]="dp1" formControlName="start_date" (click)="dp1.open()">
        <mat-datepicker-toggle matSuffix [for]="dp1"></mat-datepicker-toggle>
        <mat-datepicker #dp1 disabled="false"></mat-datepicker>
      </mat-form-field>

      <mat-form-field [hideRequiredMarker]="hideRequiredControl.value" class="form-date-field margin-left"
        appearance="outline">
        <mat-label class="alt-inter-medium alt-size-16 alt-color-grayscale1">{{"USERS.date-end" | translate }}</mat-label>
        <input #date2 matInput [min]="minDate" [matDatepicker]="dp2" readonly formControlName="ending_date" (click)="dp2.open()">
        <mat-datepicker-toggle matSuffix [for]="dp2"></mat-datepicker-toggle>
        <mat-datepicker #dp2 disabled="false"></mat-datepicker>
      </mat-form-field>
    </div>

    <button class="btn-create-user alt-inter-semibold alt-size-14 pointer" type="button" [disabled]="alliedForm.invalid"
      mat-stroked-button (click)="openSnackBar()" [class.btn-disabled]="alliedForm.invalid">
      {{"USERS.create-user" | translate | uppercase}}
    </button>

  </form>
</div>
